import { render, staticRenderFns } from "./CreateEditUserGroupModal.vue?vue&type=template&id=c854b9fa"
import script from "./CreateEditUserGroupModal.vue?vue&type=script&lang=ts"
export * from "./CreateEditUserGroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports